import React from 'react';

function PageNotFound() {
  return (
    <div>
      <div>404</div>
      <div>Page cannot be found</div>
    </div>
  );
}

export default PageNotFound;
